import React, { useState , useRef, useEffect} from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import './StyledCalendar.css';
import './FullCalendar.css'; 
import { useTranslation } from 'react-i18next';
import allLocales from '@fullcalendar/core/locales-all';
import Aos from "aos";
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';
import UpcomingEvents from '../components/events/UpcomingEvents';
import { useLocation } from 'react-router-dom';
import EventDetails from '../components/events/EventDetails';
import {ReactComponent as CalendarSVG} from '../assets/svgs/calendar.svg'

const Page = styled.div`
  margin: 30px 50px 50px 50px;
  @media (max-width: 768px) {
    margin:20px 20px;
    margin-bottom:100px;
  }
`;

const Header = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;

    @media (max-width: 768px) {
     flex-direction:column; 
     justify-content: center;
     align-items:center;
     text-align: center;
     margin-bottom: 50px;

     svg{
      width: 20px;
     }
    }
`;

const Link = styled.a`
  color: #385963;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
     @media (max-width: 768px) {
    font-size: 14px;
   }
`;

const Title = styled.div`
  font-size: 40px;
  // display: flex;
  color: #385963;
  font-weight: 500;
  margin-bottom: 5px;
  align-items:center;
  @media (max-width: 768px) {
    font-size: 18px;
   }
`;

const Description = styled.div`
  font-size: 20px;
  margin-bottom: 50px;
  color: #91abb3;
   @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom:20px;
   }
`;

const FullCalendarWrapper = styled.div`
  .fc {
    max-width: 70vw; /* Adjust width */
    margin: 0 auto;
  }

  /* Style for header buttons */
  .fc-toolbar-button {
    background-color: rgb(69, 175, 207); /* Default background color */
    border: none; /* Remove border */
    color: white; /* Default text color */
    transition: background-color 0.3s ease, color 0.3s ease; /* Smooth transition */
    cursor: pointer; /* Pointer cursor on hover */
  }

    .fc-toolbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .fc-toolbar-button:hover {
    background-color: #91abb3 !important; /* Hover background color */
    color: white; /* Hover text color */
  }

  /* Remove underline from day numbers */
  .fc-daygrid-day-number {
    text-decoration: none; /* Remove underline */
  }

  .fc .fc-button-primary {
    background-color: rgb(29, 184, 231); /* Default background color */
    border:none;
  }

  .fc .fc-button-primary:hover{
     background-color: rgb(47, 126, 190); /* Default event color */
  }  

  .fc-daygrid-day-number:hover {
    text-decoration: none; /* Ensure no underline appears on hover */
  }

  .fc-event {
    background-color: rgb(47, 126, 190); /* Default event color */
    color: white;
    transition: background-color 0.3s ease, transform 0.2s ease; /* Smooth transition */
  }

  .fc-event:hover {
    background-color:rgb(98, 187, 214); /* Hover color */
    cursor: pointer; /* Pointer cursor on hover */
    transform: scale(1.02); /* Optional: Slight zoom effect */
  }


    .fc-toolbar-chunk {
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {

    .fc {
        max-width: 80vw; /* Adjust width */
        margin: 0 auto;
      }

    .fc-toolbar {
      flex-direction: column;
      align-items: center;
      gap: 10px;
        margin-bottom:20px;
    }

    .fc-toolbar-chunk:nth-of-type(1) { /* Title */
      order: 1;
    }

    .fc-toolbar-chunk:nth-of-type(2) { /* Center buttons (if any) */
      order: 2;
    }

    .fc-toolbar-chunk:nth-of-type(3) { /* Right buttons */
      order: 3;
    }
  }

  .fc-toolbar-title {
    font-size: 25px;
    font-weight: bold;
    margin-bottom:20px;
  }

  .fc-button {
    margin: 0 4px;
  }


  
`;


const InfoContainer = styled.div`
   display:flex;
   flex-direction:column;
`;

const LinkContainer = styled.div`
   display:flex;
   gap:5px;
   a{
   cursor: pointer;
   color: #91abb3;
    |:hover{
      text-decoration:underlined;
      
    }
   }

   @media (max-width: 768px) {
     flex-direction:column; 
     justify-content: center;
     align-items:center;
     text-align: center;
     font-size: 14px;
    }
`;

const Events = () => {

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  
    useEffect(()=>{
      Aos.init({duration:1000})
    },[]);  
  
    const customLocales = {
      en: {
        code: 'en',
        weekText: 'Wk', // Example override
        allDayText: 'All-day', // Custom translation
        today: 'Today', // Custom translation
      },
      el: {
        code: 'el',
        weekText: 'Εβδομάδα',
        allDayText: 'Ολοήμερο', // Greek translation
        today: 'Σήμερα', // Greek translation
      },
    };

    const loggedIn = sessionStorage.getItem("loggedIn");
    const { i18n } = useTranslation();
    const locale = `${i18n.language}-${i18n.language === 'el' ? 'GR' : 'US'}`;
    const tokenString = sessionStorage.getItem('token');
    const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const calendarRef = useRef(null); // Reference to the FullCalendar instance
  
    const [events, setEvents] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const location = useLocation();
    const { state } = location;

     const [activeComponent, setActiveComponent] = useState(state?.activeComponent || 'calendar');

     useEffect(() => {
           if (state?.activeComponent) {
             setActiveComponent(state.activeComponent);
           }
         }, [state]);

         const handleEventDetailsNavigation = (component, id) => {
          // Navigate to the /destinations page with active tab information
          navigate('/event-calendar', { state: { activeComponent: component, eventId: id  } });
        
        };
        
        const handleUpcomingEventsNavigation = (component) => {
          // Navigate to the /destinations page with active tab information
          navigate('/event-calendar', { state: { activeComponent: component } });
        
        };
  
    useEffect(() => {
      const fetchEvents = async () => {
        try {
          const response = await fetch(
            `${BASE_URL}Event`);
           
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          const data = await response.json();
          const transformedEvents = data.map(event => ({
            id: event.id,
            title: event.name[selectedLanguage],
            start: event.startDate,
            end: event.endDate,
            description: event.description[selectedLanguage],
            extendedProps: {
              description: event.description[selectedLanguage],
              location: event.location,
              email: event.email,
              phone: event.phone,
              providerName: event.providerName,
              siteLink: event.siteLink,
            },
          }));

          setEvents(transformedEvents);
        } catch (error) {
          if (error.message.includes('404')) {
            console.error(`Category ID not found: ${error.message}`);
          } else {
            console.error('Error fetching data:', error);
          }
        }
      };
  
      fetchEvents();
    }, [tokenString, selectedLanguage]);
  
  return (
    <Page>
      <Header>
        <InfoContainer>
          <Title >{i18n.t('newsTitle')}<CalendarSVG  height={40} width={40} style={{ marginLeft: '15px' }} /></Title>
          <Description>{i18n.t('eventsDescription')}</Description>
       </InfoContainer>
       {!loggedIn &&
        <LinkContainer>
       </LinkContainer>}
      </Header>
    

      {activeComponent==='calendar' && (
        <FullCalendarWrapper>
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={events}
            selectable={true}
            // eventClick={handleEventClick}
            locale={selectedLanguage} // Dynamically set based on the selected language
            locales={allLocales}  
            allDayText={selectedLanguage === 'gr' ? '' : ''}
            buttonText={{
              today: selectedLanguage === 'gr' ? 'Σήμερα' : 'Today', // Conditional translation
              // month: selectedLanguage === 'gr' ? 'Μήνας' : 'Month',
            }}
            customButtons={{
              showUpcoming: {
                text: selectedLanguage === 'gr' ? 'Επερχόμενες εκδηλώσεις' : 'Upcoming Events',
                click: () =>  handleUpcomingEventsNavigation('upcomingEvents'), // Switch to Upcoming Events
              },
            }}
              headerToolbar={{
                left: 'title', // Keep the month name on the left
                center: '', // No buttons in the center
                right: 'showUpcoming today prev,next', // Add custom button next to the existing ones
              }}
              eventClick={(info) => {
                // Remove the tooltip when clicking on the event
                const tooltipId = info.el.dataset.tooltipId; // Get the tooltip ID from the event element
                const tooltip = document.getElementById(tooltipId);
                if (tooltip) {
                  tooltip.remove(); // Remove the tooltip if it exists
                  delete info.el.dataset.tooltipId; // Clean up the reference
                }
            
                // Existing functionality for eventClick
                setSelectedEvent(info.event.id);
                handleEventDetailsNavigation('eventDetails' , info.event.id);
              }}
              eventMouseEnter={(info) => {
                const tooltip = document.createElement('div');
                tooltip.id = `event-tooltip-${info.event.id}`; // Unique ID for the tooltip
                tooltip.style.position = 'absolute';
                tooltip.style.zIndex = '1000';
                tooltip.style.background = '#91abb3';
                tooltip.style.color = 'white';
                tooltip.style.padding = '5px 10px';
                tooltip.style.borderRadius = '5px';
                tooltip.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
                tooltip.innerText = info.event.title;
            
                // Position the tooltip near the event
                tooltip.style.top = `${info.jsEvent.pageY + 10}px`;
                tooltip.style.left = `${info.jsEvent.pageX + 10}px`;
            
                document.body.appendChild(tooltip);
            
                // Store tooltip reference in the event element
                info.el.dataset.tooltipId = tooltip.id;
              }}
              eventMouseLeave={(info) => {
                const tooltipId = info.el.dataset.tooltipId; // Get the tooltip ID
                const tooltip = document.getElementById(tooltipId);
                if (tooltip) {
                  tooltip.remove(); // Remove the tooltip
                  delete info.el.dataset.tooltipId; // Clean up the reference
                }
              }}
          />
        </FullCalendarWrapper>
      )}


   {activeComponent === 'eventDetails' && <EventDetails />}
   {activeComponent === 'upcomingEvents' && <UpcomingEvents />}
    </Page>
  );
};

export default Events;
